import { useEffect } from 'react';
import {PDFDocument} from 'pdf-lib';
// import generalDonationPDF from './assets/generic_donation_form.pdf';
// import psDonationPDF from './assets/ps_donation_form.pdf';
const generalDonationPDF = 'https://d3p12cfhe1hrbz.cloudfront.net/assets/WHMW_Generic_Donation_Form_Fillable.pdf';
const psDonationPDF = 'https://media.pancan.org/purplestride/Donation%20Form/PS_Generic_Donation_Form.pdf';

interface Props {
  data:any;
}



function App(props:Props) {
  const fetchPDFFile = async(campaign:string) => {      
    const fileURL = (campaign === 'diy')? generalDonationPDF: psDonationPDF;
    const res:any = await fetch(fileURL).then(data => data.arrayBuffer()).then((buffer:any) => new Uint8Array(buffer)).catch(error =>  {console.log('Error fetching the file', error); return false;});
    if(!res) return false;
    return res;    
  }

  const generatePDF = async() => {
    const {eventName, type, teamName, consName, campaign, donationId, teamId, frId, diyType} = props.data;    
    const donationFormFile:any = await fetchPDFFile(campaign);
    if(!donationFormFile) return;
    const pdfDoc = await PDFDocument.load(donationFormFile);
    const form = pdfDoc.getForm();    
    const fields = form.getFields();
    
    fields.forEach((field:any) => {
      const fieldName = field.getName();
      console.log(fieldName);
      
      if(campaign === 'diy'){
        console.log(diyType);
        
        if(diyType && diyType === 'tribute'){
          if(fieldName === 'Type Tribute Organizer') field.setText(`${consName}                            ${donationId}                          ${frId}`);
          if(fieldName === 'Type Honoree Name' && type === 'team') field.setText(`${teamName}                            ${donationId}`);
          if(teamId && type === 'individual' && fieldName === 'Type Honoree Name' && teamName)  field.setText(`${teamName}                            ${teamId}`);
        } else {          
          if(fieldName === 'Name of Participant/Fundraiser/Individual') field.setText(`${consName}                            ${donationId}                      ${frId}`);
          if(fieldName === 'Type Team Name' && type === 'team') field.setText(`${teamName}                            ${donationId}`);  
          if (teamId && type === 'individual' && fieldName === 'Type Team Name' && teamName)  field.setText(`${teamName}                            ${teamId}`);
        }
      } else {
        // For PS Only
        // const teamorconsname = type === 'team' ? teamName: consName;
        if (fieldName === 'EVENT NAME') field.setText(`${eventName}                 ${frId}`);               
        if (fieldName === 'Participant/Fundraiser/Individual Name' && type === 'individual') field.setText(`${consName}                            ${donationId}`);               
        if (fieldName === 'Team Name' && type === 'team') field.setText(`${teamName}                            ${donationId}`);  
        if (teamId && type === 'individual' && fieldName === 'Team Name' && teamName)  field.setText(`${teamName}                            ${teamId}`);
      }
      
    });

    const filledFormBytes = await pdfDoc.save();
    const blob = new Blob([filledFormBytes], {type: 'application/pdf'});
    const url = URL.createObjectURL(blob);   
    const link: any = document.createElement('a');
    link.href = url;
    link.download = (campaign === 'diy')?'general-donation-form.pdf': 'purplestride-donation-form.pdf';
    link.click();
    // return window.open(link.href);    
    return window.location.href = url;
  }

  

  useEffect(() => {
    generatePDF();
  });

  return (
    <div className="app-pdf-container">
      Loading...
    </div>
  );
}

export default App;
